import './application';
import '../apps/peak_3d/peak3d';
import { createApp } from 'vue';
import Peak3DOverlay from '../apps/peak_3d/Peak3DOverlay.vue';
import store from '../apps/peak_3d/store';

const overlayEl = document.getElementById('peak-3d-overlay');
if (overlayEl) {
  createApp(Peak3DOverlay).use(store).mount('#peak-3d-overlay');
}
